// extracted by mini-css-extract-plugin
export var bounce = "_oa-1";
export var generatingText = "_oa-6";
export var lightning = "_oa-4";
export var popup = "_oa-5";
export var progressBar = "_oa-7";
export var progressFill = "_oa-8";
export var progressShimmer = "_oa-9";
export var progressText = "_oa-a";
export var shimmer = "_oa-3";
export var uploadIcon = "_oa-0";
export var uploadingText = "_oa-2";